// extracted by mini-css-extract-plugin
export default {"button":"addtocart_button__JZD4r"};